
	export enum MarkerType{
		CIRCLE,
		HIGHLIGHT
	}

	export class Marker {
		timestamp: number;
		value: number = 0;
		color: string;
		type: MarkerType = MarkerType.CIRCLE;

	}
